shadow$provide[269] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Transform4:{enumerable:true, get:function() {
  return Transform4;
}}});
var require$_DOT__SLASH_transform_DOT_js = require("./transform.js");
class Transform4 extends require$_DOT__SLASH_transform_DOT_js.Transform {
  static initClass() {
    this.traits = ["node", "vertex", "transform4"];
  }
  make() {
    this.uniforms = {transformMatrix:this._attributes.make(this._types.mat4()), transformOffset:this.node.attributes["transform4.position"],};
    return this.transformMatrix = this.uniforms.transformMatrix.value;
  }
  unmake() {
    return delete this.uniforms;
  }
  change(changed, touched, init) {
    if (changed["transform4.pass"]) {
      return this.rebuild();
    }
    if (!touched["transform4"] && !init) {
      return;
    }
    const s = this.props.scale;
    const m = this.props.matrix;
    const t = this.transformMatrix;
    t.copy(m);
    return t.scale(s);
  }
  vertex(shader, pass) {
    if (pass === this.props.pass) {
      shader.pipe("transform4.position", this.uniforms);
    }
    return super.vertex(shader, pass);
  }
}
Transform4.initClass();

};